import React from 'react'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { formatDateTime } from 'common/usual'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core'
import EditBtn from 'components/EditBtn'

const MealPlanTable = props => {
  const { data } = props

  return (
    <Card>
      <CardContent className={'table-content'}>
        <PerfectScrollbar>
          <div className={'inner'}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Meals Per Day</TableCell>
                  <TableCell>Diet</TableCell>
                  <TableCell>Active</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {data && data.map(plan => (
                  <TableRow className={'table-row'} key={plan.id} hover>
                    <TableCell>{plan.id}</TableCell>
                    <TableCell>{plan.mealsPerDay}</TableCell>
                    <TableCell>{plan.diet && plan.diet.title}</TableCell>
                    <TableCell>{plan.active ? 'TRUE' : 'FALSE'}</TableCell>
                    <TableCell>{formatDateTime(plan.createdAt)}</TableCell>
                    <TableCell>
                      <EditBtn history={props.history} path={`/meal-plan/edit/${plan.id}`} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
  )
}

export default MealPlanTable